module.exports = __webpack_public_path__ + "img/ine-ife.d4608667.png";